export default __webpack_public_path__ + "static/media/polk_p_common.3cd49e62.png";